import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { CommonDialog } from 'src/components/shared/dialog/CommonDialog';
import { getQueryParam } from 'src/lib/utils';

export const FortuneExchangeFailedDialog = () => {
  const { t } = useTranslation(['fortune', 'translation']);
  const location = useLocation();
  const title = t('translation:dialog_error');
  const errorParam = getQueryParam(location.search, 'error');
  // クエリが存在しない場合は、空の文言を出力
  const description = errorParam ? getErrorDescription(t, errorParam) : '';
  return <CommonDialog title={title} description={description} />;
};

// helper function
// クエリのエラー内容に従って、ダイアログ本文を出力する関数
function getErrorDescription(t: TFunction, error?: string): string {
  switch (error) {
    case 'unstable-network':
      return t('translation:error_unstable_network');
    case 'exceeded-exchanged-item-storage':
      return t('error_reached_server_storage_limit');
    case 'exceeded-number-of-changes':
      return t('error_reached_exchange_limit');
    case 'lack-of-points':
    case 'exchange-invalid-item':
    case 'invalid-date':
      return t('error_failed_to_exchange');
    default:
      return t('translation:error_unknown');
  }
}
